import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

class AboutUs extends React.Component {
    state = { statments : [] }

    constructor(props, context) {
        super(props, context);
        this.state = {
            bodyData: undefined
        };
    }
    
    componentDidMount() {
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //this.getPage();
        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                this.setLog('pages/log/Help_Search/visit/'+res.IPv4.replaceAll('.',','))
            })
            .catch(err => this.setLog('pages/log/Help_Search/visit/'+err));
    }
    
    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/701/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/701/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    
        const pageHtml = await webapi.get('pages/htmlpages/701/'+this.state.LanguageInfo[0].Code);   
        //console.log(bodyList);     
        this.setState({
            pageHtmlData: pageHtml.data
        });
    }
    
    render() {
        if (this.state.LanguageInfo && this.state.pageData && this.state.pageHtmlData) {
            return  (
                [
                    <div>
                        <Header LanguageInfo = {this.state.LanguageInfo}/>
                        <div className="container-fluid" id="innerpage_row_1">
                            <div className="container">
                                <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F701!== undefined?this.state.pageData[0].F701:701/*راهنمای جستجو در پایگاه*/}</h1>
                            </div>
                        </div>
                        
                        <div className="container-fluid">
                            <div className="container container_70">
                                {
                                    this.state.pageHtmlData.map((HtmlParagraph,i) =>{  
                                        return(
                                            HtmlParagraph != null 
                                            ?
                                            (
                                                <div key={'a'+i}>
                                                    {/*
                                                    <section
                                                        className="data-title"
                                                        dangerouslySetInnerHTML={{ __html:HtmlParagraph.H701}}  
                                                    />*/
                                                    }
                                                    <section
                                                        className="data-body"
                                                        dangerouslySetInnerHTML={{ __html:HtmlParagraph.H701}}  
                                                    />
                                                    <br />
                                                </div>
                                            )
                                            :
                                            (
                                                null
                                            )
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div> 
                    ,
                    <Footer Lang = {this.state.LanguageInfo[0].Code}/>
                ]
            );
        } else {
            return  (
                        <div></div>
                    )
        }
    }
 }

 export default AboutUs;